// Repairs listing photo URLs that arrive JSON-escaped from the API.
//
// The Wiggot webhook writes the *cover* photo (element 0 of a listing's
// photo array) double-encoded, so `/search` hands us
// "https:\/\/media.wiggot.mx\/izHcfVg-l.jpg" instead of the plain URL.
// Every other photo in the same listing is clean.
//
// This breaks <img src> and nothing else: the URL parser collapses the
// backslashes but leaves a doubled slash in the path
// (https://media.wiggot.mx//izHcfVg-l.jpg), and the Wiggot CDN answers
// that with a 404 whose *body is a grey placeholder PNG*. The browser
// decodes it happily, fires `load` rather than `error`, and the card
// renders someone else's "no image" graphic with no way to detect it.
// CSS `background-image: url(...)` is immune — `\/` is a valid CSS
// escape for `/` — which is why the detail-page gallery looked fine
// while the cards did not.
//
// Non-strings pass through untouched so callers can hand us a possibly
// undefined `item.photo` without guarding first.
export const normalizePhotoUrl = (url) =>
    typeof url === "string" ? url.replace(/\\\//g, "/") : url;
